export class Stage {
  _id?: string;
  name?: string;
  description?: string;
  owner?: string;
  shared_w?: string[];
  shared_r?: string[];
  project?: any;
  company?: any;
  parentStage?: string | Stage | null;
  createdAt?: Date;
  updatedAt?: Date;
  number_measurements: number;
}
